<template>
  <div class="bg-lighter full-view">
    <b-container fluid>
      <b-row>
        <div class="nextstrain-btn-container" @click="selected=0">
          <div v-show="selected==0" class="nextstrain-btn nextstrain-btn-selected pt-2">
            <h4 class="nextstrain-btn-text">Denmark <b-icon class="nextstrain-icon" font-scale="1" icon="check-square"></b-icon></h4>
            <!-- <p class="nextstrain-btn-text">Phylogenetic analysis of Covid19 genomes from humans, samples with a focus on Denmark</p> -->
          </div>
          <div v-show="selected!=0" class="nextstrain-btn pt-2">
            <h4 class="nextstrain-btn-text">Denmark <b-icon class="nextstrain-icon" font-scale="1" icon="square"></b-icon></h4>
            <!-- <p class="nextstrain-btn-text">Phylogenetic analysis of Covid19 genomes from humans, samples with a focus on Denmark</p> -->
          </div>          
        </div>

        <div class="nextstrain-btn-container" @click="selected=1">
          <div v-show="selected==1" class="nextstrain-btn nextstrain-btn-selected pt-2">
            <h4 class="nextstrain-btn-text">Mink <b-icon class="nextstrain-icon" font-scale="1" icon="check-square"></b-icon></h4>
            <!-- <p class="nextstrain-btn-text">Phylogenetic analysis of Covid19 genomes from mink, including a large fraction of samples from Denmark</p> -->
          </div>
          <div v-show="selected!=1" class="nextstrain-btn pt-2">
            <h4 class="nextstrain-btn-text">Mink <b-icon class="nextstrain-icon" font-scale="1" icon="square"></b-icon></h4>
            <!-- <p class="nextstrain-btn-text">Phylogenetic analysis of Covid19 genomes from mink, including a large fraction of samples from Denmark</p> -->
          </div>          
        </div>
      </b-row>
      <b-row class="mt-2">
        <b-col v-if="selected==0">
          <b-embed
            type="iframe"
            aspect="16by9"
            :src="url_denmark"
            allowfullscreen
          ></b-embed>
        </b-col>
        <b-col v-else>
          <b-embed
            type="iframe"
            aspect="16by9"
            :src="url_mink"
            allowfullscreen
          ></b-embed>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
export default {
  data() {
    return {
      selected: 0,
    };
  },
  computed: {
    url_mink() {
      return this.$store.getters.n_mink_url;
    },
    url_denmark() {
      return this.$store.getters.n_denmark_url;
    },
  },
};
</script>

<style scoped>
.nextstrain-btn-container{
  text-align: left;
  display:block;
}

.nextstrain-btn {
  display:table-cell;
  vertical-align:middle;
  width: 200px;
  height:50px;
  border-bottom: 1px solid #090d54;
  border-right: 1px solid #090d54;
}

.nextstrain-btn-text {
  padding-left:10px;
}

.nextstrain-icon{
  float:right;
  padding-right:10px;
}

.nextstrain-btn:hover{
  /* background-color: rgb(214, 226, 253); */
  cursor:pointer
}

.nextstrain-btn-selected{
  background-color:#090d54;
  color:white;
}

</style>